import React, { FC } from 'react';
import Link from '@loomstateorg/shared-frontend/components/commercetools-ui/atoms/link';
import Typography from '@loomstateorg/shared-frontend/components/commercetools-ui/atoms/typography';
import { useFormat } from '@loomstateorg/shared-frontend/hooks/useFormat';
import Image, { NextFrontasticImage } from 'frontastic/lib/image';
import { SocialMedia } from '.';

interface Props {
  logo?: NextFrontasticImage;
  socialMedia?: SocialMedia[];
}

const FooterBottom: FC<Props> = ({ logo, socialMedia }) => {
  const { formatMessage } = useFormat({ name: 'common' });
  const year = new Date().getFullYear();

  return (
    <>
      <div className="flex flex-col items-center py-32" data-testid="footer-bottom">
        <ul className="mb-20 flex flex-row gap-20 self-center" data-testid="social-media-list">
          {socialMedia?.map((item, i) => (
            <li key={i} className="w-22">
              <Link link={item.reference} className="cursor-pointer" data-testid={`social-media-${i}`}>
                <img src={item?.logo?.media?.file} className="mb-16" />
              </Link>
            </li>
          ))}
        </ul>
        <Typography fontFamily="primaryThin" fontSize={14} className="text-center" data-testid="copyright">
          {formatMessage({
            id: 'footer.copyright',
            defaultMessage: `© ${year} Loomstate LLC. All rights reserved.`,
            values: { year },
          })}
        </Typography>
      </div>
    </>
  );
};

export default FooterBottom;
